export default __webpack_public_path__ + "static/media/transfacil_galery_7.4b989745.jpg";